import React, {FC} from 'react';
import styled, {useTheme} from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {BannerText} from '../../../../../libs/shared/ui/src/components/banners/bannerText';
import {
  AnalyticsErrorBannerState,
  AnalyticsErrorBannerTypesEnum,
} from '../../../../store/panels/app/banners/bannersState';

/*
 * Props.
 */

interface AnalyticsErrorBannerProps {
  banner: AnalyticsErrorBannerState;
  onClose: () => void;
}

/*
 * Styles.
 */

const StyledWrappedTextDiv = styled.div`
  white-space: normal;
`;

/*
 * Component.
 */

export const AnalyticsErrorBanner: FC<AnalyticsErrorBannerProps> = (props) => {
  const {onClose, banner} = props;

  const theme = useTheme();

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      priority={BannerPrioritiesEnum.ERROR}
      color={theme.palette.red.shade40}
    >
      <BannerIcon iconName="warningFilledSmall" />
      <BannerText>{renderAnalyticsErrorBannerContent(banner)}</BannerText>
      <BannerCloseAction onClick={onClose} />
    </Banner>
  );
};

export function renderAnalyticsErrorBannerContent({
  analyticsErrorType,
  analyticsError,
}: AnalyticsErrorBannerState) {
  switch (analyticsErrorType) {
    case AnalyticsErrorBannerTypesEnum.CONVERSATION_STAGES_EDIT_FAILED:
      return (
        <BannerContent>
          <BannerText>
            <StyledWrappedTextDiv>
              {analyticsError ?? (
                <Trans id="banner-analytics-conversation-stages-error">
                  An error occurred, please try again or contact support@frontapp.com.
                </Trans>
              )}
            </StyledWrappedTextDiv>
          </BannerText>
        </BannerContent>
      );
    default:
      return null;
  }
}
